export enum ReservationStatus {
  CREATED,
  GUEST_NOT_ARRIVED,
  GUEST_ARRIVED,
  RESERVATION_DONE,
  // Gość wyszedł – ustawiane przez sync GoPOS po zamknięciu rachunku (CLOSED).
  // Realny czas wyjścia zapisujemy w reservations.left_at; dostępność liczy
  // koniec blokady jako left_at + 30 min bufora, BEZ zmiany godzin rezerwacji.
  GUEST_LEFT,
}
